import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function HorizontalBarCard({
    title = "Screened & Examined",
    categories = [],
    screened = [],
    examined = [],
}) {
    const data = {
        labels: categories,
        datasets: [
            {
                label: "Screened",
                data: screened,
                backgroundColor: "#11cdef",
                borderRadius: 10,
                barThickness: 14,
            },
            {
                label: "Examined",
                data: examined,
                backgroundColor: "#5e72e4",
                borderRadius: 10,
                barThickness: 14,
            },
        ],
    };

    const options = {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,   // IMPORTANT for fixed height
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    boxWidth: 12,
                    color: "#334155",
                },
            },
            tooltip: {
                backgroundColor: "#fff",
                borderColor: "#e2e8f0",
                borderWidth: 1,
                titleColor: "#1e293b",
                bodyColor: "#1e293b",
                cornerRadius: 8,
            },
            datalabels: false
        },
        scales: {
            x: {
                ticks: { color: "#475569" },
                grid: { display: false },
            },
            y: {
                ticks: { color: "#475569", font: { size: 12, weight: "500" } },
                grid: { display: false },
            },
        },
    };

    return (
        <div
            className="bg-white rounded-xl shadow-md p-4 "
            style={{ height: "420px" }}   // FIXED CARD HEIGHT
        >
            {/* Header */}
            <div className="flex items-center justify-between mb-2">
                <h3 className="text-sm font-semibold text-slate-700">
                    {title}
                </h3>
                <i className="fa fa-bars text-lg text-slate-500"></i>
            </div>

            {/* Chart FULL HEIGHT */}
            <div style={{ height: "350px" }}>   
                <Bar data={data} options={options} />
            </div>
        </div>
    );
}
